import React, { useEffect, useState } from "react";
import { useAuth } from "component/UseAuth";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import axios from "axios";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import GroupAccountDatatables from "component/akunting/master/group account/GroupAccountTable";
import GroupAccountForm from "component/akunting/master/group account/GroupAccountForm";

function GroupAccount() {
  const { user } = useAuth();
  const [data, setData] = useState([
    {
      group_account_table: "",
      group_account_div: "",
      div_code: "",
      group_account_dep: "",
      dep_code:"",
      group_account_code:"",
      int_code: "",
      group_account_desc: "",
      entry_by: "",
      reg_desc: "",
    },
  ]);
  const [modalMode, setModalMode] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const fetchGroupAccount = async (user) => {
    const token = localStorage.getItem("token");
    const reg_desc = user?.company;
    try {
      const response = await fetch(`${process.env.REACT_APP_API}/show-group-account`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ reg_desc })
      });
  
      if (!response.ok) throw new Error("Gagal mengambil data Group Account");
  
      const data = await response.json();
      setData(data.data);
    } catch (error) {
      console.error("Error fetching Group Account:", error);
    }
  };

  useEffect(() => {
    document.title = "Green Hill Kemuning | Group Account";
    window.scrollTo(0, 0);
    fetchGroupAccount(user);
  }, []);

  const handleAddGroupAccount = () => {
    setModalMode("add");
    setIsModalOpen(true);
  }
  
  const closeModal = () => {
    setIsModalOpen(false);
  }

  const handlePrint = () => {
    // window.print(); // atau arahkan ke halaman cetak khusus
  };

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Sidebar />

        <div className="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
          <Navbar />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <div className="row px-4">
                <div className="card shadow p-3">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="card-title m-0">Group Account Management</h5>

                      <div className="d-flex gap-1">
                        <i className="bx bxs-plus-square" 
                          style={{ color: "blue", fontSize: 30, cursor: "pointer" }} 
                          onClick={handleAddGroupAccount}>
                        </i>
                        <i
                          className="bx bxs-printer"
                          title="Print"
                          style={{ color: "blue", fontSize: 30, cursor: "pointer" }} 
                          onClick={handlePrint}
                        ></i>
                      </div>
                    </div>

                    <GroupAccountDatatables data={data} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>

        {isModalOpen && (
          <div className="modal fade show" style={{ display: "block" }}>
            <GroupAccountForm mode={modalMode} user={user} closeModal={closeModal} onSuccess={fetchGroupAccount}/>
          </div>
        )}
      </div>
    </div>
  );
}

export default GroupAccount;
